import React from 'react';

type Props = {
  imageUrl?: string;
  title?: string;
  copy?: string;
};

export const CareerFullWidthMedia = ({ imageUrl, title, copy }: Props) => {
  return (
    <div className="career-fwm media-cover">
      {imageUrl && <img src={imageUrl} alt="Careers at Alo" loading="lazy" />}
      {(title || copy) && (
        <div className="career-fwm__content">
          <div className="career-fwm__content-inner">
            {title && <h5 className="h5 uppercase career-fwm__title">{title}</h5>}
            {copy && <div className="body" dangerouslySetInnerHTML={{ __html: copy }}></div>}
          </div>
        </div>
      )}
    </div>
  );
};
